@let altNavItem = this.altNavItem();
@let basketCount = this.basketCount();
<div class="icon-container"
     #iconContainer
     [class.disabled]="isBasketEmpty()"
     tabindex="0"
     [pTooltip]="isPopoverOpen() ? undefined : (altNavItem.nameKey | msgKeyCached)"
     tooltipPosition="bottom"
     tooltipEvent="both"
     (keydown.enter)="onClick($event)">
	<a #popoverTarget
	   (click)="onClick($event)"
	   tabindex="-1">
		@if (basketCount) {
			<p-overlay-badge [value]="basketCount"
			                 badgeSize="small">
				<mat-icon svgIcon="{{altNavItem.icon}}"
				          class="default-icon"></mat-icon>
				<mat-icon svgIcon="{{altNavItem.icon + '_hover'}}"
				          class="hover_icon"></mat-icon>
			</p-overlay-badge>
		} @else {
			<mat-icon svgIcon="{{altNavItem.icon}}"
			          class="default-icon"></mat-icon>
			<mat-icon svgIcon="{{altNavItem.icon + '_hover'}}"
			          class="hover_icon"></mat-icon>
		}
	</a>
</div>
<p-popover #popover (onShow)="onPopoverShow()" (onHide)="isPopoverOpen.set(false)" [dt]="popoverDt">
	<div #popoverContent
	     pFocusTrap
	     (keydown.escape)="onPopoverEscape($event)">
		@for (link of altNavItem.children; track link.url) {
			<div class="tooltip-link-Container">
				<a tabindex="0"
				   [routerLink]="link.url"
				   [queryParams]="link.query">{{link.nameKey | msgKeyCached}}</a>
			</div>
		}
	</div>
</p-popover>